import * as React from 'react';

import Fields from './Fields';
import { PkpassFieldsType } from '../../../../types';

export default function AuxiliaryFields(): JSX.Element {
  return <Fields fieldsType={PkpassFieldsType.AuxiliaryFields} />;
}
